// «Close shift» bits shared by the launch modal and the device buttons that open it.
import { t } from '../ui/lang';
import { can } from '../core/access';
import { resolveFarmRecordById } from '../farms/farms-view';
import { openCloseShiftModal } from './close-shift-modal';
/** A film-frame glyph for «close shift»: the run's product is a video. */
export const SHIFT_ICON = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="13" height="14" rx="2"/><path d="m16 10 5-3v10l-5-3"/><circle cx="9.5" cy="12" r="2"/></svg>`;
/** Stop a device's «close shift» run after a confirm. */
export async function stopCloseShift(farmId, udid) {
    if (!confirm(t('shifts.confirm_stop')))
        return false;
    try {
        const res = await fetch(`/api/farms/${farmId}/clicker/devices/${encodeURIComponent(udid)}/close-shift/stop`, { method: 'POST' });
        if (res.ok)
            return true;
        alert((await res.json().catch(() => ({}))).error || t('shifts.failed_to_stop'));
    }
    catch {
        alert(t('shifts.failed_to_stop'));
    }
    return false;
}
/** The «close shift» control of a device's side column, hidden until the team's switch is known. */
export function closeShiftBtnHtml(cls) {
    return can('clicker.closeShift')
        ? `<button type="button" class="stream-control-btn ${cls}" title="${t('shifts.close_shift')}" aria-label="${t('shifts.close_shift')}" disabled style="display:none">${SHIFT_ICON}</button>`
        : '';
}
/** Closing a shift needs the phone to itself, so the button is live only while the clicker is down. */
export function syncCloseShiftBtn(card, cls, clickerRunning) {
    const btn = card.querySelector(`.${cls}`);
    if (!btn)
        return;
    btn.disabled = clickerRunning;
    btn.title = t(clickerRunning ? 'shifts.close_shift_busy' : 'shifts.close_shift');
    btn.setAttribute('aria-label', btn.title);
}
/**
 * Wire a cloud card's (duo / GeeLark) «close shift» button: shown once the farm's team is
 * known to have it on (teams.close_shift); the modal itself offers Stop for a running shift.
 */
export function wireCloseShiftBtn(card, cls, farmId, udid) {
    const btn = card.querySelector(`.${cls}`);
    if (!btn)
        return;
    void resolveFarmRecordById(farmId).then((farm) => { if (farm?.close_shift)
        btn.style.display = ''; });
    btn.addEventListener('click', (e) => {
        e.stopPropagation();
        openCloseShiftModal(farmId, udid);
    });
}
